<template>
    <div class="test-statistics-table">
        <h2 v-if="title" class="test-statistics-table-title">{{title}}</h2>
        <table class="table is-fullwidth">
            <thead>
            <tr>
                <th v-for="(header, index) in headers" :key="index">
                    {{ transHeader(header.key) }}
                    <help-tooltip v-if="header.description_key" :text="transHeader(header.description_key)" :left="true"/>
                </th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(item, id) in tableData" :key="id">
                    <td v-for="header in headers">
                        <template v-if="!header.link">{{ item[header.value] }}</template>
                        <span v-else @click.stop="linkCollback(item)" class="to-details">
                            {{ item[header.value] }}
                            <template v-if="isShowEmail">
                                <br/>
                                ({{ item.email }})
                            </template>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import HelpTooltip from "../../../utils/HelpTooltip.vue";

export default {
    name: "TestStatisticsTable",
    components: {HelpTooltip},
    props: {
        tableData: {
            type: [Object, Array],
            default: () => {},
        },
        headers: {
            type: Array,
            default: () => [],
        },
        linkCollback: {
            type: Function,
            default: () => {},
        },
        title: {
            type: String,
            default: '',
        },
        isShowEmail: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
        ]),
    },
    methods: {
        ...mapActions('tests', [
            'showTestStatisticDetail',
        ]),
        transHeader(key) {
            return this.trans.statistics.table_headers[key];
        }
    }
}
</script>

<style scoped lang="scss">

.test-statistics-table {
    .table {
        th,td {
            vertical-align: middle;
            text-align: center;
            .to-details {
                color: #1c6ca1;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
        }

        tr td,th{
            &:not(:first-child) {
                width: 130px;
            }

            &:first-child {
                text-align: left;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 300px;
            }
        }
    }

    .test-statistics-table-title {
        font-size: 1.4rem;
        font-weight: 600;
        padding: 0 10px;
        margin-top: 2rem;
    }
}
</style>